'use strict';

module.exports.FLOW_TYPES = {
    OAUTH: 'oauth',
    INTERNAL: 'internal',
    LINK: 'link'
};

module.exports.CHECK_URL_OPTIONS = {
    /* eslint-disable camelcase */
    require_tld: false,
    require_valid_protocol: false,
    require_host: false
    /* eslint-enable camelcase */
};

module.exports.ACCOUNT_TYPES = {
    USER: 'user',
    ADMIN: 'admin'
};

module.exports.SERVICE_ACCOUNT_TYPES = {
    TEACHER: 'teacher',
    USER: 'user',
    ADMIN: 'admin'
};

module.exports.USER_STATUS = {
    REMOVED: 0, // can be restored by admin
    ACTIVE: 1
};

module.exports.AUTHORIZE_STATUS = {
    ACCOUNT_EXISTS: 'account_exists',
    UNAUTHORIZED: 'unauthorized',
    AUTHORIZED: 'authorized'
};

module.exports.ERROR_STATUS = {
    UNAUTHORIZED: 'unauthorized',
    ACCOUNT_NOT_FOUND: 'account_not_found',
    ACCOUNT_REMOVED: 'account_removed',
    ACCOUNT_UNACTIVATED: 'account_unactivated',
    INCORRECT_PASSWORD: 'incorrect_password',
    PASSWORD_NOT_EXISTS: 'password_not_exists'
};

module.exports.LOCALES = {
    RU: 'ru',
    EN: 'en'
};

module.exports.MAILING_METHODS = {
    VK: 'VK',
    EMAIL: 'EMAIL',
    NONE: 'NONE'
};

module.exports.MIN_PASSWORD_LEN = 6;

module.exports.RESPONSE_STATUS = {
    OK: 200,
    INCORRECT_DATA: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500
};

// При добавлении новых типов уведомлений нужно обновлять этот список
module.exports.NOTIFICATION_TYPES = {
    CONTEST_WILL_START: 'contest_will_start',
    CONTEST_WILL_END: 'contest_will_end',
    CONTEST_STARTED: 'contest_started',
    GROUP_STATS: 'group_stats',
    TEST_SOLUTION: 'test_solution',
    APPLICATION_TO_GROUP: 'application_to_group',
    GROUP_MEMBERSHIP: 'group_membership',
    MESSAGE_FROM_SENDER: 'message_from_sender',
    MESSAGE_NEW_TEACHER: 'message_new_teacher',
    COMMENT_UPDATED: 'solution_comment_updated',
    QUESTION_UPDATED: 'solution_question_updated'
};
